module.exports = __webpack_public_path__ + "img/calendar.f1a4d079.svg";